import { BookingDeleteRefusedError } from './api/bookings';
import type { MessageKey, Vars } from '../i18n';

/**
 * The sentence for an activity removal the server refused (#1380), or `null`
 * when `e` is not one.
 *
 * Deleting an activity with its courts (`deleteActivities`, releaseBookings)
 * and the automatic cancellation free the activity's own court reservations
 * through the check every removal asks (`refusedRemoval` on the server). A
 * refusal changed NOTHING — no activity deleted or cancelled, nobody refunded —
 * so the sentence says that, and the way out, in the reader's language. The
 * code stays a code until here: it is the screen that turns it into words.
 */
export function activityRemovalRefusalMessage(
  e: unknown,
  t: (key: MessageKey, vars?: Vars) => string,
): string | null {
  if (!(e instanceof BookingDeleteRefusedError)) return null;
  const n = String(Math.max(1, e.bookings.length));
  switch (e.code) {
    case 'booking_has_payment':
      return t('activities.removalRefused.hasPayment', { n });
    case 'booking_payment_open':
      return t('activities.removalRefused.paymentOpen', { n });
    case 'booking_has_payment_link':
      return t('activities.removalRefused.paymentLink', { n });
    case 'state_moved':
      return t('activities.removalRefused.moved');
    default:
      return t('activities.removalRefused.other');
  }
}
